import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

// The blue app-switcher button is not a KeyDS variant — managed-care-ui styles a
// plain button with the information token, inverting on hover and going white
// while its popover is open. Ported as-is so the two apps match.
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  /* The blue block spans the full height of the top bar. Set explicitly rather
     than relying on the parent's flex stretch, so an align-items rule added to
     the nav section later cannot shrink it. */
  height: 100%;

  padding: 0 ${rem(spacing.base * 2.2)};

  border: none;
  cursor: pointer;

  color: ${toColorString(color.base.snowWhite)};
  background-color: ${toColorString(color.status.information.dark)};

  ${({ $active }) =>
    !$active &&
    css`
      &:hover,
      &:active {
        color: ${toColorString(color.status.information.dark)};
        background-color: ${toColorString(color.status.information.light)};
      }
    `}

  ${({ $active }) =>
    $active &&
    css`
      color: ${toColorString(color.base.charcoal)};
      background-color: ${toColorString(color.base.snowWhite)};
    `}
`;

export default Button;
